import { Divider } from '@mui/material';
import { IOnlineTourPresentationResult } from '../utils/types';
import { Fragment, useEffect, useState } from 'react';
import { onlineTourDetailPresentation } from '../api';
import { useTranslation } from 'react-i18next';
import { HtmlContent } from './HtmlContent';
import PageHeader from './PageHeader';

type OnlineTourDetailPresentationProps = {
  tourId: number;
  onEmptyDetails?: (hasData: boolean) => void;
};

export default function OnlineTourDetailPresentations({
  tourId,
  onEmptyDetails,
}: OnlineTourDetailPresentationProps) {
  const { t } = useTranslation();
  const [error, setError] = useState<string>();
  const [loading, setLoading] = useState<boolean>(true);
  const [
    onlineTourDetailPresentationResult,
    setOnlineTourDetailPresentationResult,
  ] = useState<IOnlineTourPresentationResult | null>(null);

  useEffect(() => {
    fetchOnlineTourDetailPresentation(tourId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tourId]);

  const fetchOnlineTourDetailPresentation = async (tourId: number) => {
    try {
      const res = await onlineTourDetailPresentation(tourId);
      const data = await res.json();

      if (res?.status === 200) {
        setOnlineTourDetailPresentationResult(data);

        if (!data.name && !data.description) {
          onEmptyDetails?.(false);
        } else {
          onEmptyDetails?.(true);
        }
      } else {
        throw data;
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      onEmptyDetails?.(false);
      setError(e.detail || t('loginPage.registerErrorMessage'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      {onlineTourDetailPresentationResult && (
        <>
          <PageHeader title={t('tourPlan.tourPresentationTitle')} />

          <HtmlContent content={onlineTourDetailPresentationResult?.name} />

          {onlineTourDetailPresentationResult?.description && (
            <Fragment>
              <Divider sx={{ my: 1 }} />
              <HtmlContent
                content={
                  onlineTourDetailPresentationResult?.description ||
                  'no description yet'
                }
              />
            </Fragment>
          )}
        </>
      )}
    </Fragment>
  );
}
